import React, { useState } from "react";

const ValueOfWhatCalculator = () => {
  const [number, setNumber] = useState("");
  const [percentage, setPercentage] = useState("");
  const [result, setResult] = useState("");
  const [error, setError] = useState("");

  const handleCalculate = () => {
    const num = parseFloat(number);
    const pct = parseFloat(percentage);
    if (isNaN(num) || isNaN(pct) || pct === 0) {
      setError("Entrez les valeurs correctes");
      setResult("");
      return;
    }
    const value = (num / (pct / 100)).toFixed(2);
    setResult(value);
    setError("");
  };

  return (
    <div>
      <u><h2 style={{ fontSize: '16px' }}>Calculatrice Valeur de Quel %</h2></u><br />
      <div className="form-group">
        <label>Nombre:</label>
        <input
          type="number"
          value={number}
          onChange={(e) => setNumber(e.target.value)}
          className="form-control"
          placeholder="Nombre"
        />
      </div>
      <div className="form-group">
        <label>Est ___% de quelle valeur?</label>
        <input
          type="number"
          value={percentage}
          onChange={(e) => setPercentage(e.target.value)}
          className="form-control"
          placeholder="Pourcentage"
        />
      </div>
      <button className="btn btn-success" onClick={handleCalculate}>
        Calculer
      </button>
      <br />
      <br />
      {error && (
        <p className="p-3 mb-2 bg-warning text-dark">Erreur: {error}</p>
      )}
      {result && (
        <p className="p-3 mb-2 bg-success text-white">
          Résultat: {number} est {percentage}% de {result}
        </p>
      )}
    </div>
  );
};

export default ValueOfWhatCalculator;
